/**
 * Skeleton component for department card loading state
 * @module components/common/DepartmentCardSkeleton
 */

import React from 'react'
import { Skeleton } from './Skeleton'

export interface DepartmentCardSkeletonProps {
  /**
   * Number of skeleton cards to display
   */
  cards?: number
}

/**
 * Department card loading skeleton
 *
 * Displays skeleton placeholders matching the structure of department cards
 */
export const DepartmentCardSkeleton: React.FC<DepartmentCardSkeletonProps> = ({
  cards = 3
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {Array.from({ length: cards }).map((_, index) => (
        <div
          key={index}
          className="p-6 bg-white rounded-lg border border-gray-200 space-y-4"
        >
          {/* Department name */}
          <Skeleton width="60%" height={24} />

          {/* Department stats */}
          <div className="space-y-2">
            <Skeleton width="80%" height={16} />
            <Skeleton width="70%" height={16} />
          </div>

          {/* Manager info */}
          <div className="flex items-center gap-3 pt-2">
            <Skeleton width={40} height={40} variant="circular" />
            <div className="flex-1 space-y-2">
              <Skeleton width="50%" height={14} />
              <Skeleton width="70%" height={12} />
            </div>
          </div>

          {/* Action */}
          <Skeleton width="100%" height={36} variant="rounded" />
        </div>
      ))}
    </div>
  )
}
